export default __webpack_public_path__ + "static/media/Logo.472cc3bf.png";